import { SxProps, Theme } from "@mui/material";

export const countdownTimerContainerStyles: SxProps = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const countdownTimerProgressContainerStyles: SxProps = {
  position: "relative",
  display: "inline-flex",
};

export const countdownTimerProgressStyles = (color: string): SxProps => ({
  position: "absolute",
  top: 0,
  left: 0,
  "& .MuiCircularProgress-circle": {
    stroke: "url(#gradient)",
  },
});

export const countdownTimerBackgroundStyles: SxProps = {
  color: "rgba(0, 0, 0, 0.1)",
};

export const countdownTimerTextContainerStyles: SxProps = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

export const countdownTimerNumberStyles = (textColor: string): SxProps => ({
  fontWeight: "bold",
  color: textColor,
  lineHeight: 1,
  fontSize: { xs: "1.125rem", sm: "1.5rem", md: "1.75rem" },
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(0, 0, 0, 0.5)",
});

export const countdownTimerLabelStyles = (textColor: string): SxProps => ({
  mt: 0.5,
  color: textColor,
  fontSize: { xs: "0.625rem", sm: "0.75rem" },
  fontWeight: 500,
  opacity: 1,
  textShadow: "1px 1px 3px rgba(0, 0, 0, 0.8), 0 0 8px rgba(0, 0, 0, 0.5)",
});
